export const RESTRICTION_LEVELS = {
  BIKE_ONLY: 'R10',
  OVER_SIZE_R5: 'R5',
  OVER_SIZE_R2: 'R2',
  GROUND_ONLY: 'R1',
} as const;

export const DEFAULT_DELIVERY_TIMES = {
  DEFAULT: '5-7',
  BIKE: '20-22',
} as const;

export const FREE_SHIPPING_TEXT = {
  EN: 'FREE',
  FR: 'GRATUIT',
} as const;
